import logoFull from './assets/images/logoFull-BW.png';
import logoMobile from './assets/images/logoMobile-BW.png';
import footerImage from './assets/images/SigninPageFooterAPSSMP.png';
import authPageImage from './assets/images/bottom-image.png';
import loghiFinanziamentoPNL from './assets/images/loghi-sibari.png';
import loghiFinanziamentoPNS from './assets/images/loghi-PN-sicurezza.png';
import packageJson from '../package.json';

/***************************************************************/
/* AUTH CONFIG */
const identityProvider = "archeo";
const keycloakConfig = {};

//********************************************************** */
/* ENVIRONMENT */
const { environment, deployment } = packageJson;

const config = {
  supportEmail: "supporto@p****.it",

  supportPhone: "+39 *** **** *****",
  
  /* TEXT TITLE */
  description: "SISTEMA INFORMATIVO PER LA GESTIONE DEI DATI ARCHEOLOGICI",

  archeoBaseUrl: "https://archeo-dev.quattroemme.it",

 
  /* GEOSERVER URL */
  geoserverUrl: "https://gs.loreb.it/geoserver/test-archeo",

  /* MULTITENANCY */
  adminOrganization: "Amministrazione di Sistema",
  comuneDefault: { nome: "ITALIA", id: "02b567fd-f8ed-4b89-bd97-bef4acffab72"},
  
  /* IDENTITY PROVIDER */
  identityProvider: "archeo",


  /* LOGOS */
  logoFull,
  logoMobile,

  /* IMAGES */
  footerImage,
  authPageImage,

  loghiFinanziamento: loghiFinanziamentoPNS,
};

export default config;
